module.exports = __webpack_public_path__ + "transfer.svg?4a754b14654a31470d5612b99b23104c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transfer.svg
// module id = 251
// module chunks = 0